import { Injectable } from '@angular/core';

import {
    ordensServicoStorage, TipoOrdemServico, OrdemServicoStatus, TipoMaterialServico,
    ordensServicoItemsStorage
} from "./data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";

@Injectable()
export class OrdemServicoService {

    constructor(
        private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(ordensServicoStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(ordensServicoStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(ordensServicoStorage + "-new");
    }
    
    setItemsSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(ordensServicoItemsStorage + '-new', object);
    }

    getItemsSessionStorage() {
        let item: string = sessionStorage.getItem(ordensServicoItemsStorage + "-new");
        return JSON.parse(item);
    }

    clearItemsSessionStorage() {
        sessionStorage.removeItem(ordensServicoItemsStorage + "-new");
    }


    getTipoOrdemServico(tipo: number) {
        let tipos: Array<any> = TipoOrdemServico,
            x: any, lenX: any;

        for (x = 0, lenX = tipos.length; x < lenX; x++) {
            if (tipos[x].Key === tipo) {
                tipo = tipos[x];
                break;
            }
        }

        return tipo;
    }

    getStatusOrdemServico(status: number) {
        let statusList: Array<any> = OrdemServicoStatus,
            x: any, lenX: any;

        for (x = 0, lenX = statusList.length; x < lenX; x++) {
            if (statusList[x].Key === status) {
                status = statusList[x];
                break;
            }
        }

        return status;
    }

    getStatusAtivo() {
        let statusList: Array<any> = OrdemServicoStatus;
        return statusList[0];
    }

    getStatusCancelado() {
        let statusList: Array<any> = OrdemServicoStatus;
        return statusList[2];
    }

    getStatusConcluido() {
        let statusList: Array<any> = OrdemServicoStatus;
        return statusList[1];
    }

    getItemTipoServico() {
        let list: any[] = TipoMaterialServico;
        return list[1];
    }

    getItemTipoMaterial() {
        let list: any[] = TipoMaterialServico;
        return list[0];
    }

    templateResult = (function(state: any, isCreateNew: boolean) {
        let stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (isCreateNew) {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                } else {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                }
            } else {
                if (state.text) {
                    text = state.text;
                } else {
                    let tipo: string = '';
                    if (state.Tipo) {
                        tipo = state.Tipo.Value;
                        tipo = " / (" + tipo + ")";
                    }

                    if (state.descricao) {
                        text = state.descricao.concat(tipo);
                    }
                }
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/shared/ordem-servico.service.ts
 **/